/**
 * InfinitSales - Blocklist de disparo (Etapa 4)
 * Contatos que nunca recebem disparo em massa (campanha, fluxo, disparo por
 * etiqueta). O enforcement é sempre-on no backend; a ESCRITA é gated por
 * DISPATCH_BLOCKLIST_ENABLED — o campo `enabled` das respostas diz à UI se os
 * controles de escrita ficam habilitados (desabilitado com motivo, nunca some).
 * Variantes do 9º dígito são o MESMO bloqueio; chave opaca (instagram:/
 * messenger:) passa intacta — a canonização é toda do backend.
 */
import api from './api';

const BASE = '/api/blocklist';

class BlocklistService {
  /** Lista completa: { data: [{contact_key, phone_raw, reason, created_at}], enabled } */
  async list() {
    const res = await api.get(BASE);
    return res.data;
  }

  /** Este contato está bloqueado? { data: { blocked }, enabled } */
  async check(phone) {
    const res = await api.get(`${BASE}/check/${encodeURIComponent(phone)}`);
    return res.data;
  }

  async add(phone, reason) {
    const res = await api.post(BASE, { phone, reason: reason || null });
    return res.data;
  }

  async remove(phone) {
    const res = await api.delete(`${BASE}/${encodeURIComponent(phone)}`);
    return res.data;
  }
}

const blocklistService = new BlocklistService();
export default blocklistService;
